<div style="margin-top: 16px; margin-bottom: 16px">
    <div class="content-block" fxLayout="row" fxLayoutAlign="space-between start" style="height: fit-content">
        <div class="dx-card" fxLayout="column" style="width: 100%; padding: 8px; margin: 6px;">
            <h5 style="margin-bottom: 8px!important;margin-top: 8px!important;">Client Information</h5>
            <address class="details">
                <span class="strong">Name:</span> {{ client? client.name : ''}}<br/>
                <span class="strong">Address:</span> {{ ClientAddress }}<br/>
                <span class="strong">Phone:</span> {{ client? client.phone : '' }}<br/>
                <span class="strong">Fax:</span> {{ client? client.fax : ''}}<br/>
            </address>
        </div>

        <div class="dx-card" fxLayout="column" style="width: 100%; padding: 8px; margin: 6px;"><!--style="border: 1px solid #e2e2e2; padding: 8px; height: inherit; width: 100%; margin: 6px;">-->
            <h5 style="margin-bottom: 8px!important;margin-top: 8px!important;">Patient Information</h5>
            <address class="details">
                <span class="strong">Patient ID:</span> {{ patient ? patient.code : '' }}<br/>
                <span class="strong">Patient:</span> {{ PatientFullName }} {{ DOB }} {{ Gender }}<br/>
                <span class="strong">Primary Physician:</span> {{ PatientPrimaryPhysician }}<br/>
                <span class="strong">Room:</span> {{ Room }} <span class="strong">Unit:</span> {{ Unit }}<br/>
                <span class="strong">Address:</span> {{ PatientAddress }}<br/>
                <span class="strong">Phone:</span> {{ patient? patient.phone : '' }}<br/>
            </address>
        </div>

        <div class="dx-card" fxLayout="column" style="width: 100%; padding: 8px; margin: 6px;">
            <h5 style="margin-bottom: 8px!important;margin-top: 8px!important;">Order Information</h5>
            <address class="details">
                <span class="strong">Collected:</span> {{ format(order.collectionDate) }} <br/>
                <span class="strong">Received:</span> {{ format(order.receivedDate) }} <br/>
                <span class="strong">Reported:</span> {{ format(order.reported, true) }}<br/>
                <span class="strong">Collection Site:</span> {{CollectionSites}} <br/>
                <span class="strong">Ordering Physician:</span> {{Physician}}
            </address>
        </div>
    </div>
</div>
